module.exports = {
  supportedLngs: ['en', 'es', 'ru'],
  fallbackLng: 'en'
}